import { el, KEYED_LIST } from "@dhx/ts-common/dom";
import { getScrollbarWidth } from "@dhx/ts-common/html";
import { ILayoutState, IRendererConfig } from "./../types";
import { getCells, getHandlers } from "./Cells";
import { getRows } from "./FixedRows";

export function getFixedCols(renderConfig: IRendererConfig, layout: ILayoutState) {
	const hiddenCheck = renderConfig.columns.reduce((check, col) => {
		return col.hidden ? check + 1 :check;
	}, 0);

	if (typeof renderConfig.splitAt !== "number") {
		return;
	}

	if (hiddenCheck === renderConfig.splitAt) {
		return;
	}
	const scrollBarWidth = renderConfig.$totalWidth <= layout.wrapper.width ? 0 : getScrollbarWidth();

	const fixedColsHeight = (layout.sticky ?
		layout.gridBodyHeight
		: layout.gridBodyHeight + renderConfig.headerHeight) - scrollBarWidth;

	const columns = renderConfig.columns.slice(0, renderConfig.splitAt);
	renderConfig.fixedColumnsWidth = columns.reduce((total, item) => total += !item.hidden ? item.width || 100 : 0, 0);
	const fixedCols = getCells({
		...renderConfig,
		columns,
		$positions: { ...renderConfig.$positions, xStart: 0, xEnd: renderConfig.splitAt }
	});

	const isSticky = layout.sticky;
	const headerRowsConfig = { ...layout, name: "header", position: "top" };
	const footerRowsConfig = { ...layout, name: "footer", position: "bottom" };

	const frozenHeaderCols = renderConfig.splitAt >= 0 && getRows(
		{
			...renderConfig,
			currentColumns: renderConfig.columns.slice(0, renderConfig.splitAt),
			$positions: { ...renderConfig.$positions, xStart: 0, xEnd: renderConfig.splitAt }
		},
		{ ...layout, name: "header", position: "top" });

	const frozenFooterCols = renderConfig.splitAt >= 0 && getRows(
		{
			...renderConfig,
			currentColumns: renderConfig.columns.slice(0, renderConfig.splitAt),
			$positions: { ...renderConfig.$positions, xStart: 0, xEnd: renderConfig.splitAt }
		},
		{ ...layout, name: "footer", position: "bottom" });

	const frozenHeader = frozenHeaderCols && el(`.dhx_${headerRowsConfig.name}-fixed-cols`, {
		style: {
			position: "absolute",
			top: 0,
			left: 0,
			zIndex: 999999,
		}
	}, frozenHeaderCols);

	const frozenFooter = isSticky ? (frozenFooterCols && el(`.dhx_${footerRowsConfig.name}-fixed-cols`, {
		style: {
			position: "absolute",
			bottom: 0,
			left: 0,
			zIndex: 999999,
		}
	}, frozenFooterCols)) : null;

	const pos = renderConfig.$positions;

	return el(".dhx_grid-fixed-cols-wrap", {
		style: {
			height: fixedColsHeight,
			paddingTop: renderConfig.headerHeight,
			overflow: "hidden",
			width: renderConfig.fixedColumnsWidth
		}
	}, [
			frozenHeader,
			el(".dhx_grid-fixed-cols", {
				style: {
					top: -renderConfig.scroll.top + renderConfig.headerHeight - 1 + "px",
					paddingTop: layout.shifts.y,
					height: renderConfig.$totalHeight,
					position: "absolute"
				},
				_flags: KEYED_LIST,
				...getHandlers(pos.yStart, pos.xStart, renderConfig)
			}, fixedCols),
			renderConfig.$footer && frozenFooter,
			el(".dhx_frozen-cols-border")

		]);
}